<div *ngIf="saUser">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>shield_person</mat-icon>
      {{ 'Secure Access User: ' + saUser.username }}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{ !saUser.id ? 'add' : 'save' }}</mat-icon>
        {{ (saUser.id ? 'Update ' : 'Add ') }}
      </button>
      <button *ngIf="siteAccessGranted === true" style="background-color: #B71C1C !important; color: white !important;"
              mat-raised-button
              (click)="revokeSecureAccess()"
              [disabled]="!authService.hasRole('SITE_ACCESS_ADMIN')">
        <mat-icon>gpp_bad</mat-icon>
        Revoke Secure Access
      </button>
      <button *ngIf="siteAccessGranted !== true" style="background-color: green !important; color: white !important;"
              mat-raised-button
              (click)="enableSecureAccess()"
              [disabled]="!authService.hasRole('SITE_ACCESS_ADMIN')">
        <mat-icon>verified_user</mat-icon>
        Enable Secure Access
      </button>
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Secure Access Settings">
      <div class="padded">
        <form #form="ngForm" role="form" class="vbox">
          <table class="basicTable vtable">
            <thead>
            <tr>
              <th colspan="100">Secure Access User</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th style="width: 150px">User</th>
              <td>{{ saUser.firstName }} {{ saUser.lastName }}</td>
            </tr>
            <tr>
              <th>Username</th>
              <td>
                <micro-user-lookup [userId]="saUser.id"></micro-user-lookup>
              </td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{{ saUser.email }}</td>
            </tr>
            <tr>
              <th>MSISDN</th>
              <td>{{ saUser.msisdn }}</td>
            </tr>
            <tr>
              <th>Company</th>
              <td>
                <micro-company-lookup [companyId]="saUser.companyId"></micro-company-lookup>
              </td>
            </tr>
            <tr>
              <th>Department</th>
              <td>
                <micro-department-lookup [departmentId]="saUser.departmentId"></micro-department-lookup>
              </td>
            </tr>
            <tr>
              <th [ngClass]="siteAccessGranted ? 'CLEARED' : 'CRITICAL'">Secure Access Enabled</th>
              <td>
                <input type="checkbox" [(ngModel)]="siteAccessGranted" id="siteAccessCheckbox"
                       name="siteAccessCheckbox">
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <micro-picklist *ngIf="allRegions"
                                [all]="allRegions"
                                [(selectedIds)]="userRegionIds"
                                displayField="name"
                                [title]="'Regions'"
                                [availableLabel]="'Available Regions'"
                                [selectedLabel]="'Assigned Regions'">
                </micro-picklist>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <micro-picklist *ngIf="allAccessCategories"
                                [all]="allAccessCategories"
                                [(selectedIds)]="userCategoryIds"
                                displayField="shortCode"
                                [title]="'Access Categories'"
                                [availableLabel]="'Available Categories'"
                                [selectedLabel]="'Assigned Categories'">

                </micro-picklist>
              </td>
            </tr>
            </tbody>
          </table>

        </form>
      </div>
    </mat-tab>
    <mat-tab label="Secure Access Audit Log">
      <micro-saContactAuditLogs #auditLogs service="SITE_ACCESS" [accessUserId]="saUser.id" [embedded]="true"></micro-saContactAuditLogs>
    </mat-tab>
    <mat-tab label="Region Audit Log">
      <micro-regionAuditLogs #regionAuditLogs [contactChanges]="true" [accessUserId]="saUser.id" [embedded]="true"></micro-regionAuditLogs>
    </mat-tab>
  </mat-tab-group>
</div>



